export const zhCN = {
  appName: "客户门户",
  appSubtitle: "订单与单据门户",
  language: {
    label: "语言",
    en: "English",
    zhCN: "简体中文",
  },
  shell: {
    navOperations: "运营",
    navInbox: "收件箱",
    navOrg: "组织",
    searchPlaceholder: "搜索订单、单据…",
    searchAria: "打开搜索",
    toggleSidebar: "切换侧栏",
    themeLight: "切换到浅色模式",
    themeDark: "切换到深色模式",
    profileMenu: "个人菜单",
    clientAdminRole: "Client Administrator",
    clientStaffRole: "Client Staff",
    storeUserRole: "Store User",
  },
  statuses: {
    order: {
      DRAFT: "草稿",
      SUBMITTED: "已提交",
      PROCESSING: "处理中",
      WAITING_CLIENT: "等待客户",
      WAITING_LOGISTICS: "等待物流",
      ON_HOLD: "挂起",
      COMPLETED: "已完成",
      CLOSED: "已关闭",
      CANCELLED: "已取消",
      REJECTED: "已驳回",
    },
    step: {
      PENDING: "待处理",
      NOT_STARTED: "未开始",
      ASSIGNED: "已分派",
      IN_PROGRESS: "进行中",
      COMPLETED: "已完成",
      SKIPPED: "已跳过",
      REJECTED: "已驳回",
      WAITING: "等待中",
      WAITING_CLIENT: "等待客户",
      WAITING_LOGISTICS: "等待物流",
      WAITING_DOCUMENT: "等待文件",
      PENDING_APPROVAL: "待审批",
      REOPENED: "已重开",
      CANCELLED: "已取消",
    },
    approval: {
      PENDING_APPROVAL: "待审批",
      APPROVED: "已通过",
      REJECTED: "已驳回",
      REVISION_REQUESTED: "要求修改",
      RESUBMITTED: "已重新提交",
      CANCELLED: "已取消",
    },
    sla: {
      OK: "正常",
      WARNING: "预警",
      APPROACHING: "即将到期",
      BREACHED: "已违约",
      OVERDUE: "超期",
      ESCALATED: "已升级",
    },
    ticket: {
      OPEN: "待处理",
      PENDING: "处理中",
      WAITING: "等待中",
      RESOLVED: "已解决",
      CLOSED: "已关闭",
    },
  },
  validation: {
    required: "此字段为必填项。",
    invalidEmail: "邮箱地址无效。",
    minLength: "至少需要 {min} 个字符。",
    networkError: "网络错误，请重试。",
    sessionExpired: "会话已过期，请重新登录。",
    somethingWrong: "出了点问题。",
    noPermission: "您没有权限执行此操作。",
  },
  common: {
    save: "保存",
    cancel: "取消",
    create: "创建",
    search: "搜索",
    retry: "重试",
    loading: "加载中…",
    pageNotFound: "页面不存在",
    pageNotFoundHint: "您访问的页面不存在。",
    goHome: "返回首页",
    yes: "是",
    no: "否",
    none: "无",
    next: "下一步",
    back: "上一步",
    prevPage: "上一页",
    nextPage: "下一页",
    rowsPerPage: "每页行数",
    submit: "提交",
    remove: "移除",
    add: "添加",
    copy: "复制",
    copied: "已复制",
    actions: "操作",
    open: "打开",
    navGroup: "导航",
    pageSummary: "第 {page} / {totalPages} 页 · 共 {total} 条",
    noData: "暂无数据",
    selectedCount: "已选 {n} 项",
    searchPlaceholder: "搜索…",
    confirm: "确认",
    loadFailed: "加载失败",
    retryLater: "请稍后重试",
    contactAdminLimit: "已达上限，请联系管理员。",
    device: "设备",
    lastActive: "最近活跃",
    current: "当前",
    other: "其他",
    noSessions: "无会话",
    invitedAt: "邀请时间",
    noInvitations: "暂无邀请",
    actor: "操作人",
    resource: "资源",
    time: "时间",
    provider: "Provider",
    model: "模型",
    openMenu: "打开菜单",
    closeMenu: "关闭菜单",
    close: "关闭",
    goTo: "跳转到…",
    noCommands: "无匹配命令",
  },
  login: {
    title: "登录",
    email: "邮箱",
    password: "密码",
    submit: "登录",
    failed: "登录失败，请检查账号密码",
    unreachable: "无法连接服务，请确认 API 已启动",
    forgotPassword: "忘记密码？",
    twoFactorTitle: "两步验证",
    twoFactorHint: "请输入验证器或邮箱中的验证码",
    twoFactorCode: "验证码",
    twoFactorSubmit: "验证并登录",
    twoFactorBack: "返回",
    twoFactorFailed: "验证码无效或已过期",
  },
  forgotPassword: {
    title: "重置密码",
    hint: "输入登录邮箱，我们将发送重置链接。",
    submit: "发送重置邮件",
    sent: "邮件已发送",
    back: "返回登录",
  },
  resetPassword: {
    title: "设置新密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    submit: "更新密码",
    ok: "密码已更新，请登录",
    fail: "重置失败",
    missingToken: "缺少重置令牌，请从邮件重新打开链接",
    mismatch: "两次密码不一致",
  },
  acceptInvite: {
    title: "接受邀请",
    body: "设置密码以加入 {name}。",
    organization: "客户企业",
    expired: "此邀请已过期",
    invalid: "此邀请无效",
    fullName: "姓名（可选）",
    password: "密码",
    confirmPassword: "确认密码",
    submit: "加入企业",
    ok: "账户已就绪，请登录。",
    fail: "邀请无效或已过期",
    mismatch: "两次密码不一致",
    passwordMin: "密码至少 10 个字符",
    missingToken: "邀请链接缺失或无效",
    goLogin: "前往登录",
  },
  twoFactorSetup: {
    title: "设置两步验证",
    body: "用验证器 App 扫描密钥后启用。",
    enable: "启用 2FA",
    disable: "关闭 2FA",
    enabled: "已启用",
    disabled: "未启用",
    scanHint: "扫码或手动输入密钥",
    manualSecret: "手动密钥",
    confirmCode: "验证码",
    confirm: "确认启用",
    passwordConfirm: "关闭前请输入登录密码",
  },
  nav: {
    home: "仪表盘",
    orderServices: "订单服务",
    tickets: "工单",
    approvals: "审批",
    announcements: "公告",
    members: "用户",
    billing: "计费账户",
    masterDocuments: "主文档库",
    endCustomers: "终端货主",
    stores: "分行",
    teams: "团队",
    settings: "设置",
  },
  clientTeams: {
    title: "团队",
    description: "客户企业团队，用于订单访问权限（非员工 RBAC）。",
    empty: "暂无团队",
    create: "新建团队",
    created: "团队已创建",
    createFail: "创建失败",
    formName: "名称",
    formDescription: "描述",
    members: "成员",
    addMember: "添加成员",
    endCustomers: "终端货主覆盖",
    addEndCustomer: "添加终端货主",
    remove: "删除团队",
    removeConfirm: "删除此团队？订单上对该团队的访问授权需另行移除。",
  },
  dashboard: {
    title: "客户仪表盘",
    description:
      "查看 {org} 进行中的订单、待您处理的事项，以及最新动态。",
    orgFallback: "您的企业",
    createOrder: "+ 新建订单服务",
    ordersProcessing: "处理中订单",
    ordersProcessingHint: "物流侧正在处理的订单服务。",
    processingEmpty: "暂无处理中订单",
    processingEmptyDesc: "新建的订单服务会出现在这里。",
    waitingMyAction: "待我处理",
    waitingMyActionHint: "需要您上传、审批或决定的事项。",
    decisionNeeded: "需要您决定：{title}",
    waitingEmpty: "暂无待办",
    waitingEmptyDesc: "您已处理完毕。",
    recentUpdates: "最近更新",
    recentUpdatesHint: "本企业最新动态。",
    updatesEmpty: "暂无动态",
    updatesEmptyDesc: "工作推进后会显示在这里。",
    stepsProgress: "{done} / {total} 步",
    dueNotStarted: "未开始",
    dueSoon: "即将到期",
    dueOverdue: "已超期",
    expiryBannerTitle: "主文档即将过期",
    expiryBannerBody:
      "{items}。请在主文档库重新上传，以便订单服务继续使用有效副本。",
    expiryItem: "{name} 于 {date} 过期（{days}）",
    daysRemaining: "剩余 {n} 天",
    daysExpired: "已过期 {n} 天",
    reviewLibrary: "查看文档库",
    metricInProgress: "进行中",
    metricWaiting: "等待中",
    metricCompleted: "已完成",
    metricOverdue: "超期",
    recentUploads: "最近上传",
    recentEmpty: "暂无上传记录",
    recentEmptyDesc: "上传文件后会显示在这里",
    viewOrders: "查看订单",
    uploadedAt: "上传时间",
  },
  orderServices: {
    title: "订单服务",
    search: "搜索编号、服务类型、货运参考号、订舱号或集装箱号",
    create: "新建订单",
    empty: "暂无订单服务",
    emptyDesc: "创建第一笔 Order Service 开始协作",
    filterAll: "全部",
    filterInProgress: "进行中",
    filterWaiting: "等待中",
    filterOverdue: "超期",
    filterCompleted: "已完成",
    colNumber: "编号",
    colService: "服务类型",
    colStore: "分行",
    colStoreAgent: "终端货主 / 分行",
    colStatus: "状态",
    colStep: "当前步骤",
    colProgress: "进度",
    overdue: "超期",
    clientAction: "需您操作",
    backToList: "返回列表",
    unassigned: "未分派",
    filterEndCustomer: "终端货主",
    colEndCustomer: "终端货主",
  },
  orderServiceDetail: {
    title: "订单详情",
    overview: "概览",
    documents: "文档",
    documentsTable: "必传与已上传文档",
    documentsColName: "文档",
    documentsColCategory: "类别",
    documentsColUploader: "上传人",
    documentsColStatus: "状态",
    documentsColActions: "操作",
    documentsCategoryRequired: "必传",
    documentsCategoryOptional: "可选",
    documentsCategoryExtra: "额外",
    documentsCategoryRemarks: "仅备注",
    documentsStep: "步骤：{name}",
    documentsNoStep: "无工作流步骤",
    documentsNotUploaded: "未上传",
    documentsSourceMaster: "主文档",
    documentsSourceOrder: "订单上传",
    atAGlance: "一眼看懂",
    serviceType: "服务类型",
    store: "分行",
    status: "状态",
    activeStep: "当前步骤",
    missingDocs: "待上传文件",
    completedWork: "已完成步骤",
    overdue: "是否超期",
    clientActionNeeded: "是否需要您操作",
    workflow: "工作流",
    workflowTitle: "工作流",
    workflowSubtitle: "{template} · {count} 个步骤 · 点击步骤查看详情",
    workflowTemplate: "模板：{name}",
    centerCurrent: "定位当前步骤",
    timelineSlaTarget: "目标",
    timelineCompleted: "已完成",
    timelineInProgress: "进行中",
    timelineApprovalRequired: "需要审批",
    timelineOverdueHint: "已超期 · 如仍阻塞请升级",
    timelineScrollLeft: "向左滚动",
    timelineScrollRight: "向右滚动",
    history: "审计追踪",
    activityEmpty: "暂无动态",
    auditColTimestamp: "时间",
    auditColUser: "用户",
    auditColAction: "操作",
    auditColResource: "资源",
    auditColIp: "IP",
    branch: "物流分行",
    priority: "优先级",
    references: "参考号",
    summaryClient: "客户",
    summaryStore: "分行",
    summaryServiceType: "服务类型",
    summaryStatus: "状态",
    summaryBranch: "分行",
    summaryOwner: "负责人",
    summaryActiveStep: "当前步骤",
    summaryResponsible: "负责人",
    unassigned: "未分派",
    progressSteps: "已完成 {done} / {total} 个必做步骤",
    progressDocs: "必传文件 {done}/{total}",
    progressRef: "参考号 {ref}",
    noActiveStep: "暂无进行中步骤",
    noMissing: "无缺失文件",
    noCompleted: "尚无已完成步骤",
    noHistory: "暂无历史",
    noNextAction: "暂无下一步",
    noAlerts: "暂无告警",
    exceptionsAlerts: "异常与告警",
    exceptionCount: "{count} 条异常",
    comments: "评论",
    access: "访问权限",
    accessBypass: "客户管理员可查看本企业全部订单。",
    accessInheritedStaff: "通过团队责任范围继承",
    accessInheritedClient: "通过客户企业团队终端货主覆盖继承",
    accessGrants: "已授权的用户与团队",
    accessDerived: "通过工作流指派",
    accessDerivedHint: "步骤指派不等于访问授权。",
    accessAddUser: "用户",
    accessAddTeam: "团队",
    accessGrant: "授权",
    accessPrincipalUser: "用户",
    accessPrincipalTeam: "团队",
    accessSourceCreator: "创建者",
    accessSourceExplicit: "已授权",
    commentsEmpty: "暂无评论",
    commentTimeline: "动态时间线",
    commentAdd: "添加评论",
    commentCommented: "发表了评论",
    commentRequestedDocument: "发起了补件请求",
    commentRequestedClose: "发起了关闭申请",
    commentPlaceholder: "输入评论…",
    commentSend: "发送",
    commentOk: "评论已发送",
    commentFail: "评论失败",
    mandatory: "必传",
    optional: "可选",
    progress: "进度",
    upload: "上传文件",
    uploadTitle: "上传文件",
    uploadBrowse: "拖放文件或点击选择",
    uploadFormats: "PDF、XLS、XLSX、DOC、DOCX、JPG、PNG · 最大 5 MB",
    takePhoto: "拍照上传",
    chooseFile: "选择文件",
    uploading: "上传中…",
    uploadOk: "上传成功",
    uploadFail: "上传失败，请重试",
    checklist: "文件清单",
    checklistEmpty: "暂无清单项",
    checklistAddExtra: "添加 Extra 文件",
    checklistDocType: "文档类型",
    checklistAddOk: "已添加清单项",
    checklistAddFail: "添加失败",
    remarksSave: "保存备注",
    remarksOk: "备注已保存",
    remarksFail: "备注保存失败",
    remarksPlaceholder: "填写备注文字…",
    linkMaster: "关联主文档",
    linkMasterPick: "选择主文档",
    linkMasterOk: "已关联主文档",
    linkMasterFail: "关联失败",
    linkMasterEmpty: "暂无主文档，请先到主文档库上传",
    masterDocs: "主文档",
    masterDocsEmpty: "暂无主文档",
    actionEdit: "编辑字段",
    editOk: "已保存",
    editFail: "保存失败",
    download: "下载",
    preview: "预览",
    deleteDoc: "删除文件",
    deleteDocOk: "已删除",
    deleteDocFail: "删除失败",
    recentUploads: "最近上传",
    commentDelete: "删除",
    commentDeleteOk: "评论已删除",
    commentDeleteFail: "删除失败",
    stepStatus: "状态",
    stepAssignedTo: "负责人",
    stepDurationSla: "时长与 SLA",
    stepElapsed: "已用时",
    stepOverdue: "超期",
    stepApproval: "审批",
    stepApprovalNotRequired: "此步骤无需审批。",
    stepClientAction: "客户操作",
    stepClientActionRequired: "此步骤需要您操作。",
    stepClientActionNotRequired: "此步骤无需客户操作。",
    stepExpectedType: "期望类型",
    stepVerified: "已核验",
    stepUploaded: "已上传",
    stepNotUploaded: "未上传",
    stepDrawerApproval: "需要审批",
    stepDrawerParallel: "并行组",
    stepDrawerSla: "SLA 目标",
    stepSlaWarning: "SLA 预警",
    stepStartedAt: "开始时间",
    stepCompletedAt: "完成时间",
    stepDrawerMinutes: "分钟",
    stepDrawerChecklist: "步骤文档",
    stepDrawerChecklistEmpty: "此步骤尚无关联文档",
    stepDrawerDocumentsLoading: "正在加载步骤文档…",
    stepDrawerDocumentsError: "无法加载步骤文档",
    stepDrawerStepOf: "第 {step} / {total} 步",
    stepDrawerComments: "步骤评论",
    stepDrawerCommentsEmpty: "此步骤暂无评论",
    stepCommentsError: "无法加载步骤评论",
    stepCommentPlaceholder: "添加关于此步骤的评论…",
    lastUpdated: "最后更新",
    shipmentDetails: "货运详情",
    shipmentVessel: "船名 / 航次",
    shipmentVoyage: "航次",
    shipmentPol: "装货港 (POL)",
    shipmentPod: "卸货港 (POD)",
    shipmentRoute: "装货港 → 卸货港",
    shipmentEta: "ETA / ETD",
    shipmentContainers: "集装箱编号",
    containerNumbersTitle: "集装箱号",
    containerOpenCount: "查看 {count} 个",
    containerPastePlaceholder: "从 Excel 粘贴，每行一个，或用逗号分隔。",
    containerValidCount: "{count} 个有效",
    containerInvalid: "不是 11 位集装箱号（4 个字母加 7 个数字）。",
    containerTooMany: "最多 200 个集装箱号。",
    containerFilter: "查找集装箱号",
    containerNoMatch: "没有匹配的集装箱号",
    containerRemove: "移除 {number}",
    shipmentCargo: "货物 / 体积",
    logisticsBranch: "物流分行",
    billingReference: "账单参考号",
    bookingNumber: "订舱号 / 提单号",
    notProvided: "未提供",
  },
  masterDocuments: {
    title: "主文档库",
    description: "本企业可复用主文档，订单清单可直接关联。",
    endCustomer: "终端货主",
    pickEndCustomer: "请选择终端货主",
    pickEndCustomerDesc: "代理组织按终端货主分别维护主文档库。",
    empty: "暂无主文档",
    emptyDesc: "上传第一份主文档",
    upload: "上传主文档",
    colName: "文件名",
    colType: "文档类型",
    colVersion: "版本",
    colExpiry: "到期日",
    docType: "文档类型",
    issueDate: "签发日期（可选）",
    expiryDate: "到期日期（可选）",
    uploadOk: "上传成功",
    uploadFail: "上传失败",
    download: "下载",
    preview: "预览",
    noExpiry: "无到期日",
    newVersion: "新版本",
    newVersionTitle: "上传新版本",
    newVersionHint: "替换当前文件并递增版本号。",
    newVersionOk: "新版本已上传",
    delete: "删除",
    deleteTitle: "删除主文档",
    deleteConfirm:
      "软删除「{name}」？已关联的订单清单仍保留历史；该文件将移出主文档库。",
    deleteOk: "已删除",
    deleteFail: "删除失败",
  },
  wizard: {
    title: "创建订单服务",
    stepOf: "第 {current} / {total} 步",
    steps: {
      SELECT_PARTIES: "选择相关方",
      SELECT_WORKFLOW_TEMPLATE: "选择工作流模板",
      CUSTOMIZE_WORKFLOW: "自定义工作流与文件",
      ENTER_ORDER_INFO: "填写订单信息",
      REVIEW_AND_SUBMIT: "核对并提交",
    },
    endCustomer: "终端货主",
    endCustomerRequired: "请选择终端货主",
    endCustomerSearch: "搜索终端货主…",
    workflowTemplate: "工作流模板",
    workflowTemplateRequired: "请选择工作流模板",
    workflowTemplateSearch: "搜索工作流模板…",
    workflowTemplateHint: "服务类型已关联到所选模板。",
    logisticsBranch: "物流分行",
    branchLockedHint: "使用您所属的物流分行。",
    customerReference: "客户参考号",
    shipmentReference: "货运参考号",
    priority: "优先级",
    remarks: "备注",
    store: "分行（可选）",
    storeSearch: "搜索分行…",
    storeNone: "不选分行",
    storeSkip: "不选分行，继续",
    customizeHint:
      "可拖动排序、编辑步骤属性，增减可选步骤与文件清单项。需要时可关联主文件。",
    addStep: "添加步骤",
    addStepName: "步骤名称",
    removeStep: "移除步骤",
    addChecklistItem: "添加清单项",
    removeChecklistItem: "移除",
    documentType: "文件类型",
    documentTypeSearch: "搜索文件类型…",
    mandatory: "必填",
    optional: "可选",
    masterDocuments: "主文件",
    masterDocumentsHint: "从该客户企业选择主文件，关联到本订单服务的文件清单。",
    masterPick: "选择主文件",
    masterSearch: "搜索主文件…",
    masterEmpty: "该客户企业暂无主文件",
    masterLinkToChecklist: "关联到清单项（可选）",
    masterLink: "关联",
    masterLinked: "已关联",
    masterLinkOk: "主文件已关联",
    checklistFromStepHint:
      "来自工作流步骤的文件不可在此删除。此处仅可删除额外添加的清单项。",
    checklistFromStep: "来自步骤",
    checklistExtra: "额外",
    uploadHint: "选择文件上传。",
    dragToReorder: "拖动以排序",
    moveUp: "上移",
    moveDown: "下移",
    stepCount: "{n} 个步骤",
    stepProperties: "步骤属性",
    stepPropertiesDesc: "编辑此草稿订单服务上的工作流步骤规则。",
    stepPropertiesOk: "步骤属性已保存",
    stepSla: "SLA（分钟）",
    stepSlaWarning: "SLA 警告（分钟）",
    stepRequired: "必做步骤",
    stepApprovalRequired: "需要审批",
    stepClientAction: "需要客户操作",
    stepCanSkip: "可跳过",
    stepCanReopen: "可重开",
    stepCanRepeat: "可重复",
    stepDocumentRequirements: "文件类型要求",
    save: "保存",
    reviewTitle: "提交前核对",
    reviewSteps: "工作流步骤",
    reviewStepsAndChecklist: "工作流步骤与文件清单",
    reviewExtraDocuments: "额外文件",
    reviewChecklist: "文件清单",
    reviewMissing: "缺少 {count} 份必填文件",
    reviewServiceType: "服务类型",
    reviewNumber: "单号",
    submit: "提交订单",
    next: "下一步",
    back: "返回",
    submitOk: "已提交",
    submitting: "提交中…",
    createFail: "创建失败，请重试",
    applyFail: "Order Service 已保存为草稿，但部分自定义未能应用，请在详情页继续完成",
    templateLoadFail: "加载 Workflow Template 失败，请重试",
    updateFail: "保存订单信息失败，请重试",
    submitFail: "提交失败，请重试",
    customizeFail: "更新工作流失败，请重试",
    priorityLow: "低",
    priorityNormal: "普通",
    priorityHigh: "高",
    priorityUrgent: "紧急",
    none: "—",
  },
  members: {
    title: "用户",
    description: "Client Admin 可管理本企业的 Client Staff 与 Branch User。",
    search: "搜索姓名或邮箱",
    add: "邀请成员",
    create: "直接创建",
    createTitle: "直接创建用户",
    createName: "姓名",
    createPassword: "密码",
    createPasswordHint: "至少 10 个字符。对方可使用该密码登录。",
    createOk: "用户已创建",
    createFail: "创建用户失败",
    empty: "暂无成员",
    emptyDesc: "邀请 Client Staff 以便协作处理订单",
    colName: "姓名",
    colEmail: "邮箱",
    colRole: "角色",
    colEndCustomers: "终端货主",
    colEndCustomerBranch: "终端货主 / 分行",
    colBranch: "分行",
    colCreated: "加入时间",
    roleAdmin: "Client Admin",
    roleStaff: "Client Staff",
    roleStoreUser: "Branch User",
    userId: "用户 ID",
    userIdHint: "发送邀请邮件；受邀人设置密码后加入本企业",
    inviteEmail: "邮箱",
    inviteHint: "系统发送邀请链接，受邀人设置密码后加入本企业。",
    inviteOk: "邀请已发送",
    inviteFail: "邀请发送失败",
    invitationsTitle: "邀请",
    invitationsDesc: "已发出、尚未加入的邀请。",
    colStatus: "状态",
    colExpires: "到期",
    statusPending: "待接受",
    statusExpired: "已过期",
    statusAccepted: "已接受",
    emptyInvitations: "没有未完成的邀请",
    searchUser: "搜索 Client 用户",
    searchUserHint: "至少输入 2 个字符（姓名或邮箱）",
    searchUserEmpty: "没有匹配的 Client 用户",
    pickUser: "选择用户",
    userIdRequired: "请填写用户 ID",
    role: "角色",
    assignEndCustomers: "分配终端货主",
    assignEndCustomersHint: "代理组织的 Client Staff 至少分配一个",
    assignStores: "分配分行",
    assignStoresHint: "分行按终端货主分组显示。",
    assignStoresUngrouped: "其他分行",
    addOk: "已添加",
    addFail: "添加失败",
    changeRole: "调整角色",
    roleUpdated: "角色已更新",
    roleUpdateFail: "角色更新失败",
    removeConfirm: "确定移除此成员？",
    removeOk: "已移除",
    removeFail: "移除失败",
    forbidden: "仅 Client Admin 可管理成员",
  },
  tickets: {
    title: "工单",
    search: "搜索主题",
    create: "新建工单",
    empty: "暂无工单",
    emptyDesc: "提交工单后物流团队会跟进",
    colSubject: "主题",
    colStatus: "状态",
    colPriority: "优先级",
    colUpdated: "更新时间",
    formSubject: "主题",
    formBody: "说明",
    formPriority: "优先级",
    priorityNormal: "普通",
    priorityHigh: "高",
    priorityLow: "低",
    reply: "回复",
    replyPlaceholder: "输入回复内容",
    createOk: "已创建",
    createFail: "创建失败",
    replyOk: "已发送",
    replyFail: "发送失败",
    back: "返回列表",
  },
  approvals: {
    title: "审批",
    description: "待你处理或需要重新提交的审批。",
    empty: "暂无审批",
    emptyDesc: "被指定为审批人或需修改时会出现在此",
    colOrder: "订单",
    colStatus: "状态",
    colAttempt: "次数",
    colUpdated: "更新时间",
    approve: "通过",
    reject: "驳回",
    rejectReason: "驳回原因",
    approved: "已通过",
    rejected: "已驳回",
    resubmit: "重新提交",
    resubmitOk: "已重新提交",
    actionFail: "操作失败",
  },
  clientConsent: {
    title: "客户决定",
    description: "同意或拒绝一项动作，例如许可证。这不会完成整个步骤。",
    empty: "暂无客户决定",
    emptyDesc: "需要您同意的请求会出现在这里。",
    colOrder: "订单",
    colTitle: "动作",
    colDays: "工作日",
    colStatus: "状态",
    statusPending: "等待您决定",
    statusAgreed: "已同意",
    statusRejected: "已拒绝",
    statusWithdrawn: "已撤回",
    days: "约 {n} 个工作日",
    penalty: "罚金说明",
    summary: "将办理的事项",
    decideHint: "先勾选，再点同意。若要拒绝，点拒绝并填写理由。",
    acknowledge: "上述罚金由本公司承担。",
    agree: "同意",
    reject: "拒绝",
    rejectReason: "拒绝理由",
    saved: "已保存",
    fail: "保存失败",
    open: "查看",
    viewOnly: "仅 Client Administrator 或 Client Staff 可以同意或拒绝。",
  },
  billing: {
    title: "计费账户",
    description: "本企业计费参考账户（只读）。",
    empty: "暂无计费账户",
    emptyDesc: "由物流公司管理员配置后显示",
    colName: "名称",
    colScope: "范围",
    colRef: "外部参考号",
    colStatus: "状态",
    scopeOrg: "企业级",
    scopeStore: "分行级",
    active: "启用",
    inactive: "停用",
    forbidden: "仅 Client Admin 可查看",
  },
  announcements: {
    title: "公告",
    empty: "暂无公告",
    emptyDesc: "物流公司发布后会出现在这里",
    markRead: "标为已读",
    unread: "未读",
    read: "已读",
  },
  settings: {
    title: "设置",
    description: "个人资料、组织信息、安全、会话与通知偏好。",
    personal: "个人",
    org: "组织",
    organization: "基本信息",
    orgName: "组织名称",
    orgForbidden: "仅 Client Admin 可更新组织信息。",
    basicInformation: "基本信息",
    formEngagement: "合作类型",
    engagementDirect: "直客",
    engagementAgent: "代理",
    corporateIdentity: "企业身份",
    legalName: "法定公司名称",
    tradeName: "商号 / 经营名称（DBA）",
    registrationNumber: "商业登记号码",
    entityType: "实体类型",
    selectEntityType: "选择实体类型",
    entityPrivateLimited: "私人有限公司（Sdn. Bhd.）",
    entityPublicLimited: "公众有限公司（Bhd.）",
    entityPartnership: "合伙",
    entitySoleProprietorship: "独资",
    entityLimitedLiabilityPartnership: "有限责任合伙",
    selectCountry: "选择国家",
    registeredAddress: "注册地址",
    operationalAddress: "经营地址",
    businessEmail: "商务邮箱",
    supportPhone: "支持电话",
    addressLine1: "地址第 1 行",
    addressLine2: "地址第 2 行（可选）",
    postalCode: "邮编",
    city: "城市",
    state: "州 / 省",
    country: "国家",
    profile: "资料",
    password: "密码",
    security: "两步验证",
    sessions: "活跃会话",
    notifications: "通知偏好",
    name: "姓名",
    locale: "语言",
    timezone: "时区",
    currentPassword: "当前密码",
    newPassword: "新密码",
    channelInApp: "站内",
    channelEmail: "邮件",
    channelSms: "短信",
    channelPush: "推送",
    typeCol: "通知类型",
    transactionalKeepOne: "此通知为必达类型，请至少保留一个渠道开启。",
    revoke: "吊销",
    saved: "已保存",
    passwordUpdated: "密码已更新",
    requestFailed: "请求失败",
    device: "设备",
    currentSession: "当前",
    otherSession: "其他",
    noSessions: "无会话",
  },
  notifications: {
    title: "通知",
    empty: "暂无通知",
    markRead: "标为已读",
    ariaLabel: "通知",
  },
  stores: {
    title: "分行",
    description: "管理本企业的分行。",
    empty: "暂无分行",
    emptyDesc: "创建分行后即可分配订单与 Branch User",
    create: "新建分行",
    edit: "编辑",
    formName: "名称",
    formCode: "代码（可选）",
    formAddress: "地址（可选）",
    formEndCustomer: "终端货主",
    created: "已创建",
    createFail: "创建失败",
    save: "保存",
    saved: "已保存",
    saveFail: "保存失败",
    deactivate: "停用",
    activate: "启用",
    colName: "分行",
    colCode: "代码",
    colEndCustomer: "终端货主",
    colStatus: "状态",
    statusActive: "启用",
    statusInactive: "停用",
    forbidden: "仅 Client Admin 可管理分行",
  },
  endCustomers: {
    title: "终端货主",
    description: "管理本代理组织下的终端货主（如 BYD、Proton）",
    empty: "暂无终端货主",
    emptyDesc: "添加终端货主以便组织分行与订单",
    create: "新建终端货主",
    edit: "编辑",
    formName: "名称",
    formCode: "编码（可选）",
    created: "已创建",
    createFail: "创建失败",
    save: "保存",
    saved: "已保存",
    saveFail: "保存失败",
    remove: "删除",
    removeOk: "已删除",
    removeFail: "删除失败",
    removeConfirm: "确定删除此终端货主？",
    colName: "名称",
    colCode: "编码",
    colStores: "分行数",
    colStatus: "状态",
    statusActive: "启用",
    statusInactive: "停用",
    deactivate: "停用",
    activate: "启用",
    forbidden: "仅代理组织的 Client Admin 可管理终端货主",
  },
  logout: "退出登录",
} as const;
